module.exports = __webpack_public_path__ + "static/media/progger4.8ebd69dd.png";